import { render, staticRenderFns } from "./BoardNoticeWebpart.vue?vue&type=template&id=3059fdba"
import script from "./BoardNoticeWebpart.ts?vue&type=script&lang=ts&external"
export * from "./BoardNoticeWebpart.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports